import { Component, OnInit } from '@angular/core';
import { MatOptionSelectionChange } from '@angular/material/core';

import { DataService } from 'src/app/shared/network/data.service';
import { ColumnForSelection } from 'src/app/shared/import/column-for-selection';
import { BaseColumnSelectComponent } from '../base-column-selection.component';
import { ImportStep } from 'src/app/shared/import/import-step';
import { ImportProgressService } from 'src/app/shared/import/import-progress.service';
import { ProjectService } from 'src/app/shared/project/project.service';

import { ControlColumnSelectionModel } from 'src/app/shared/import/control-column-selection-model';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  templateUrl: './control-column-selection.component.html',
  styleUrls: ['../../general.scss', '../column-selection.scss']
})
export class ControlColumnSelectComponent extends BaseColumnSelectComponent implements OnInit {
    projectId: string;
    columns: ColumnForSelection[];
    selectedColumn: ColumnForSelection;
    selectedOldControlValue: string;
    selectedNewControlValue: string;
    namedRangesFoundInFile: string[] = [];
    
    loading = false;
    dataLoaded = false;

    constructor(private dataService: DataService, private activatedRoute: ActivatedRoute,
        private router: Router, private importProgressService: ImportProgressService, private projectService: ProjectService) {
        super();
    }

    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe((queryParams: any) => {
            let projectId = queryParams.projectId;
            if (projectId) {
                this.projectId = projectId;
                this.projectService.setProjectId(projectId);
                this.dataService.get<ControlColumnSelectionModel>('columnSelection/control/' + projectId)
                    .then(resp => {
                        this.columns = resp.columns;
                        this.namedRangesFoundInFile = resp.namedRangesFoundInFile.map(x => '"' + x + '"');
                        let selectedColumn = this.columns.filter(c => c.isSelected)[0];
                        this.selectColumn(selectedColumn);
                        if (resp.selectedOldControlValue && resp.selectedNewControlValue 
                                && selectedColumn.usefulVals.indexOf(resp.selectedOldControlValue) >= 0
                                && selectedColumn.usefulVals.indexOf(resp.selectedNewControlValue) >= 0) {
                            this.selectedOldControlValue = resp.selectedOldControlValue;
                            this.selectedNewControlValue = resp.selectedNewControlValue;
                        }
                        this.dataLoaded = true;
                    });
            }
        });
    }

    selectColumn(column: ColumnForSelection): void {
        super.selectColumn(column);
        this.selectedOldControlValue = column.usefulVals[0];
        this.selectedNewControlValue = column.usefulVals[1];
    }

    oldControlValChanged($event: MatOptionSelectionChange) {
        let newVal = $event.source.value;
        if ($event.isUserInput && this.selectedNewControlValue == newVal) {
            this.selectedNewControlValue = this.selectedOldControlValue;
        }
    }

    newControlValChanged($event: MatOptionSelectionChange) {
        let newVal = $event.source.value;
        if ($event.isUserInput && this.selectedOldControlValue == newVal) {
            this.selectedOldControlValue = this.selectedNewControlValue;
        }
    }

    selectOldControlValue(val: string) {
        let prevVal = this.selectedOldControlValue;
        this.selectedOldControlValue = val;
        if (this.selectedNewControlValue == val) {
            this.selectedNewControlValue = prevVal;
        }
    }

    selectNewControlValue(val: string) {
        let prevVal = this.selectedNewControlValue;
        this.selectedNewControlValue = val;
        if (this.selectedOldControlValue == val) {
            this.selectedOldControlValue = prevVal;
        }
    }

    async save() {
        if (this.loading){
            return;
        }
        try {
            this.loading = true;
            await this.dataService.post('columnSelection/control', {
                projectId: this.projectId,
                columnIndex: this.columns.indexOf(this.selectedColumn),
                oldControlVal: this.selectedOldControlValue,
                newControlVal: this.selectedNewControlValue,
            });
            this.importProgressService.setImportStep(ImportStep.outcomeColumn);
            this.router.navigateByUrl('/select-column-outcome?projectId=' + this.projectId);
        } finally {
            this.loading = false;
        }
    }
}
